angular.module('leanlaw').controller('MatterBillingActivityCtrl', ['$scope', function ($scope) {
  $scope.vm = {
    module: $scope.module
  };
}]);